import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaAdjunto, TerceroUPPasarelaAdjuntoVersion} from '../_models/tercero-up-pasarela-adjunto';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaAdjuntoService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasAdjuntos';

  constructor(private httClient: HttpClient) {
  }

  listAdjuntos(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/listAdjuntos/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarelaAdjunto[]));
  }

  crearAdjuntoVersion(registro: Partial<TerceroUPPasarelaAdjunto>) {
    return this.httClient.post(`${this.rutServicio}/createPasareleVersion`, registro).pipe(map(res => res as TerceroUPPasarelaAdjuntoVersion));
  }

  inhabilitarAdjunto(registro: Partial<TerceroUPPasarelaAdjunto>) {
    return this.httClient.post(this.rutServicio, registro);
  }
}
